/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const TrashIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 12.7 14'
			style={{
				enableBackground: 'new 0 0 12.7 14'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<path
				d='M12.2 2.6H9.4v-.8C9.4.8 8.6 0 7.6 0H5C4 0 3.2.8 3.2 1.8v.8H.5c-.3 0-.5.2-.5.5s.2.5.5.5h.8v8.6c0 1 .8 1.8 1.8 1.8h6.5c1 0 1.8-.8 1.8-1.8V3.6h.8c.3 0 .5-.2.5-.5s-.3-.5-.5-.5zm-8-.8c0-.4.4-.8.8-.8h2.6c.4 0 .8.4.8.8v.8H4.2v-.8zm6.2 10.4c0 .4-.4.8-.8.8H3.1c-.4 0-.8-.4-.8-.8V3.6h8v8.6z'
				style={{
					fill: color
				}}
			/>
		</svg>
	)
}

export default TrashIcon
